import {
  createApi,
  // fetchBaseQuery,
  // FetchArgs,
} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}User/`), // Use enhanced base query
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: () => ({
        url: "GetUsers",
        method: "GET",
      }),
    }),

    authenticateUser: builder.mutation({
      query: (body) => ({
        url: "AuthenticateUser",
        method: "POST",
        body,
      }),
    }),

    addUser: builder.mutation({
      query: (body) => ({
        url: "RegisterUser",
        method: "POST",
        body,
      }),
    }),

    updateUser: builder.mutation({
      query: (body) => ({
        url: "UpdateUser",
        method: "PUT",
        body,
      }),
    }),

    deleteUser: builder.mutation({
      query: (id) => ({
        url: `DeleteUser?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useAuthenticateUserMutation,
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userApi;

export default userApi.reducer;
